<template>
  <ul class="m-utool">
    <li v-for="tool in data" :key="tool.id" :class="itemClasses(tool)" @click="$emit('input', tool.id)"></li>
  </ul>
</template>
<script>
export default {
  name: 'uTool',
  props: {
    value: {
      type: Number
    },
    data: {
      type: Array
    }
  },
  computed: {
    itemClasses() {
      return (item) => {
        const arr = [item.name]
        if (item.id === this.value) arr.push('active')
        return arr
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.m-utool {
  height: 100%;
  border-right: 2px solid #333;
  background-color: rgba(120, 120, 120, 0.5);

  li {
    height: 50%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 70%;

    &.active {
      border: 2px solid rgba(11, 150, 249, 0.5);
    }

    &.iphone8 {
      background-image: url('~assets/images/iphone8/iphone8.png');
    }

    &.iphoneX {
      background-image: url('~assets/images/iphoneX/iphoneX.png');
    }
  }
}
</style>
